module.exports = __webpack_public_path__ + "img/jewelry.213e5b1.png";